<app-topmenu
  [courseName]="configuration?.courseName"
  [menu]="configuration?.menu"
  [nextDecision]="nextDecision"
></app-topmenu>
<app-header [pageName]="texts?.pageTitle"></app-header>
<div id="main-content" *ngIf="configuration?.displayTeamMode != 'OnlyUserName'">
  <app-memberlist
    [members]="members"
    [texts]="texts"
    *ngIf="displayView === 'list'"
    (addMemberClicked)="addMemberClicked($event)"
    (lostPasswordClicked)="lostPasswordClicked($event)"
    (updateMemberClicked)="updateMemberClicked($event)"
    (removeMemberClicked)="removeMemberClicked($event)"
  ></app-memberlist>
  <app-member-edit
    *ngIf="displayView === 'edit'"
    [data]="memberEdited"
    [texts]="texts"
    [errorMessage]="errorMessage"
    (cancelled)="editCancelled($event)"
    (submitted)="editSubmitted($event)"
  ></app-member-edit>
  <app-member-remove
    *ngIf="displayView === 'remove'"
    [data]="memberEdited"
    [texts]="texts"
    [errorMessage]="errorMessage"
    (cancelled)="removeCancelled($event)"
    (submitted)="removeSubmitted($event)"
  ></app-member-remove>
  <app-password-lost
    *ngIf="displayView === 'password'"
    [data]="memberEdited"
    [texts]="texts"
    [errorMessage]="errorMessage"
    (cancelled)="lostPasswordCancelled($event)"
    (submitted)="lostPasswordSubmitted($event)"
  ></app-password-lost>
</div>

<div id="main-content" *ngIf="configuration?.displayTeamMode == 'OnlyUserName'">
  <app-membernames-list
    [members]="members"
    [texts]="texts"
  ></app-membernames-list>
</div>

<app-footer></app-footer>

<div class="snackbar" id="snackbar-black">
  {{ toastMessage }}
</div>
